export default __webpack_public_path__ + "static/media/9.e6d8b1d7.jpg";